export namespace InterfaceEnums {
  export enum Theme {
    Light = "light",
    Dark = "dark",
  }
}
